import { render, staticRenderFns } from "./FlowchartNodeView.vue?vue&type=template&id=2c5fd1aa&scoped=true"
import script from "./FlowchartNodeView.vue?vue&type=script&lang=js"
export * from "./FlowchartNodeView.vue?vue&type=script&lang=js"
import style0 from "./FlowchartNodeView.vue?vue&type=style&index=0&id=2c5fd1aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5fd1aa",
  null
  
)

export default component.exports